import React, { useEffect, useState } from "react";
import { Typography, Autocomplete, TextField } from "@mui/material";

function EditItemKitchen({ kitchens, foodItems, getKitchens }) {
  const [selections, setSelections] = useState({});

  console.log(foodItems);
  useEffect(() => {
    if (!foodItems || !kitchens) return;

    const initialSelections = foodItems.reduce((acc, foodItem) => {
      const sectionId = foodItem.foodItemSectionId || foodItem.linkedSectionId;
      const restaurant =
        kitchens.find(k => k.id === foodItem.foodItemRestaurantId) ||
        kitchens.find(k => k.id === foodItem.linkedRestaurantId);

      if (restaurant && restaurant.kitchens) {
        const selectedKitchen = restaurant.kitchens.find(k => k.id.toString() === foodItem.kitchenId.toString());

        if (sectionId) {
          acc[sectionId] = {
            foodItemId: foodItem.id,
            id: selectedKitchen ? selectedKitchen.id : null,
            kitchenName: selectedKitchen ? selectedKitchen.kitchenName : null
          };
        }
      }
      return acc;
    }, {});

    setSelections(initialSelections);
  }, [foodItems, kitchens]);

  const handleSelectionChange = (foodItem, newKitchen) => {
    const sectionId = foodItem.foodItemSectionId || foodItem.linkedSectionId;
    if (!sectionId) return;

    setSelections(prev => {
      const updatedSelections = {
        ...prev,
        [sectionId]: {
          foodItemId: foodItem.id,
          id: newKitchen ? newKitchen.id : null,
          kitchenName: newKitchen ? newKitchen.kitchenName : null
        }
      };

      if (getKitchens) {
        getKitchens(updatedSelections);
      }
      console.log(updatedSelections);
      return updatedSelections;
    });
  };
  return (
    <div>
      {foodItems.map(foodItem => {
        const restaurant =
          kitchens.find(k => k.id === foodItem.foodItemRestaurantId) ||
          kitchens.find(k => k.id === foodItem.linkedRestaurantId);

        const kitchenOptions = restaurant ? restaurant.kitchens : [];
        const sectionId = foodItem.foodItemSectionId || foodItem.linkedSectionId;
        const selectedKitchen = selections[sectionId] || null;

        return (
          <div key={foodItem.id} style={{ marginBottom: "1rem" }}>
            <Typography variant="h6" sx={{marginTop:"1rem"}}>{foodItem.title}</Typography>

            <Autocomplete
              options={kitchenOptions}
              getOptionLabel={(option) => option.kitchenName || "Unknown Kitchen"}
              value={selectedKitchen ? kitchenOptions.find(k => k.id === selectedKitchen.id) || null : null}
              onChange={(event, newValue) => handleSelectionChange(foodItem, newValue)}
              renderInput={(params) => <TextField {...params} label="Select Kitchen" variant="outlined" />}
              sx={{ width: "100%", maxWidth: "400px",marginTop:"1rem" }}
            />
          </div>
        );
      })}
    </div>
  );
}

export default EditItemKitchen;
